import React, { useEffect } from 'react';
import Canvas2D from './renderer/Canvas2D';
import Toolbar from './ui/Toolbar';
import Header from './ui/Header';
import PropertiesPanel from './ui/PropertiesPanel';
import FurnitureCatalogPanel from './ui/FurnitureCatalogPanel';
import FurniturePropertiesPanel from './ui/FurniturePropertiesPanel';
import OpeningCatalogPanel from './ui/OpeningCatalogPanel';
import LogoPanel from './ui/LogoPanel';
import LogoPropertiesPanel from './ui/LogoPropertiesPanel';
import BackgroundPanel from './ui/BackgroundPanel';
import BackgroundPropertiesPanel from './ui/BackgroundPropertiesPanel';
import TextPanel from './ui/TextPanel';
import TablePanel from './ui/TablePanel';
import ShapePanel from './ui/ShapePanel';
import ShapePropertiesPanel from './ui/ShapePropertiesPanel';
import LayersPanel from './ui/LayersPanel';
import StairsCatalogPanel from './ui/StairsCatalogPanel';
import NorthArrowPanel from './ui/NorthArrowPanel';
import AuthScreen from './ui/AuthScreen';
import ToastContainer from './ui/ToastContainer';
import GlobalConfirmationDialog from './ui/GlobalConfirmationDialog';
import useAuthStore from './store/useAuthStore';
import { authFetch } from './api';
import subscriptionManager from './core/subscriptionManager';

const App = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isCheckingSession = useAuthStore((state) => state.isCheckingSession);
  const login = useAuthStore((state) => state.login);
  const logout = useAuthStore((state) => state.logout);
  const setSubscription = useAuthStore((state) => state.setSubscription);

  useEffect(() => {
    let isMounted = true;

    const refreshSubscription = async (userId) => {
      const subscription = await subscriptionManager.getActiveSubscription(userId);

      if (isMounted) {
        setSubscription(subscription);
      }

      return subscription;
    };

    const checkSession = async () => {
      const response = await authFetch('get-session');

      if (!isMounted) return;

      if (response?.status === 'success' && response?.data?.user) {
        const user = response.data.user;
        localStorage.setItem('user_id', user.id);
        login(user);

        await refreshSubscription(user.id);

        if (!isMounted) return;

        subscriptionManager.restorePendingProject();
      } else {
        localStorage.removeItem('user_id');
        setSubscription(null);
        logout();
      }
    };

    const handleWindowFocus = () => {
      const state = useAuthStore.getState();
      const userId = localStorage.getItem('user_id');

      if (userId && state.isAuthenticated) {
        refreshSubscription(userId);
      }
    };

    checkSession();
    window.addEventListener('focus', handleWindowFocus);

    return () => {
      isMounted = false;
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, []);

  if (isCheckingSession) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-100">
        <div className="text-sm text-gray-500">Sprawdzanie sesji...</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen w-full bg-gray-100 overflow-hidden font-sans">
      {!isAuthenticated && <AuthScreen />}
      <ToastContainer />
      <GlobalConfirmationDialog />
      <Header />
      <div className="flex-1 flex relative overflow-hidden">
        <Toolbar />
        <div className="flex-1 relative bg-gray-50">
          <Canvas2D />
          <FurnitureCatalogPanel />
          <FurniturePropertiesPanel />
          <OpeningCatalogPanel />
          <StairsCatalogPanel />
          <NorthArrowPanel />
          <LogoPanel />
          <LogoPropertiesPanel />
          <BackgroundPanel />
          <BackgroundPropertiesPanel />
          <TextPanel />
          <TablePanel />
          <ShapePanel />
          <ShapePropertiesPanel />
          <LayersPanel />
        </div>
        <PropertiesPanel />
      </div>
    </div>
  );
};

export default App;